import React from "react";
// Removed: import InstagramIcon from "@mui/icons-material/Instagram"; // No longer needed
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import "./Footer.css";

// URL for the custom Instagram icon
const INSTAGRAM_ICON_URL = "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-512.png";

export default function Footer() {
  return (
    <Box className="footer" backgroundColor="secondary.main">
      <div className="left-footer">
        <Button
          className="footer-button"
          variant="contained"
          href="tel:3233256314"
          startIcon={<PhoneIcon />}
          sx={{ mr: 1 }}
        >
          Call us: 323-325-6314
        </Button>

        <Button
          className="footer-button"
          variant="contained"
          href="mailto:shawnsxmastrees@gmail.com"
          startIcon={<EmailIcon />}
        >
          ShawnsXmasTrees@gmail.com
        </Button>
      </div>

      <Box className="right-footer">
        <Typography variant="body2" align="center" color="text.main">
          © 2025 Wilk Events
        </Typography>

        <Link
          href="https://www.instagram.com/shawn_christmas_trees/"
          target="_blank"
          rel="noopener"
        >
          {/* Replaced InstagramIcon with a standard img tag using your provided URL */}
          <img 
            className="socialMedia" // Keep the class for styling
            src={INSTAGRAM_ICON_URL} 
            alt="Instagram" 
            style={{ width: '24px', height: '24px' }} // You might need to adjust the size
          />
        </Link>
      </Box>
    </Box>
  );
}